
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    RANGEWEDGEPLAY_ACTION,
    FETCH_RANGEWEDGEPLAY,
    ADD_RANGEWEDGEPLAY,
    GET_RANGEWEDGEPLAY,
    EDIT_RANGEWEDGEPLAY,
    DELETE_RANGEWEDGEPLAY,
    RANGECHIPPING_ACTION,
    FETCH_RANGECHIPPING,
    ADD_RANGECHIPPING,
    GET_RANGECHIPPING,
    EDIT_RANGECHIPPING,
    DELETE_RANGECHIPPING,
    RANGEBUNKERPLAY_ACTION,
    FETCH_RANGEBUNKERPLAY,
    ADD_RANGEBUNKERPLAY,
    GET_RANGEBUNKERPLAY,
    EDIT_RANGEBUNKERPLAY,
    DELETE_RANGEBUNKERPLAY,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Range Intervention Short Game Actions
 */

    export const fetchRangeWedgePlay = (id, startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate
        }
        return (dispatch) => { 
            dispatch({ type:RANGEWEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchrangewedgeplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_RANGEWEDGEPLAY, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const addRangeWedgePlay = (data, id) =>{
    
        var payload={
            "student":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGEWEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addrangewedgeplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeWedgePlay(id)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_RANGEWEDGEPLAY});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const getRangeWedgePlay = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGEWEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getrangewedgeplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: GET_RANGEWEDGEPLAY, payload: resdata.data[0]});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editRangeWedgePlay = (data, id, stdid) =>{
    
        var payload={
            "id":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGEWEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editrangewedgeplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeWedgePlay(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_RANGEWEDGEPLAY});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteRangeWedgePlay = (id, stdid) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGEWEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleterangewedgeplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeWedgePlay(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_RANGEWEDGEPLAY});                    
                }
                
                
            });
        
        }
    }
   

    // Chipping Intervention
    export const fetchRangeChipping = (id, startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate
        }
        return (dispatch) => { 
            dispatch({ type:RANGECHIPPING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchrangechipping', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_RANGECHIPPING, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const addRangeChipping = (data, id) =>{
    
        var payload={
            "student":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGECHIPPING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addrangechipping', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeChipping(id)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_RANGECHIPPING});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const getRangeChipping = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGECHIPPING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getrangechipping', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: GET_RANGECHIPPING, payload: resdata.data[0]});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editRangeChipping = (data, id, stdid) =>{
    
        var payload={
            "id":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGECHIPPING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editrangechipping', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeChipping(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_RANGECHIPPING});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteRangeChipping = (id, stdid) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGECHIPPING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleterangechipping', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeChipping(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_RANGECHIPPING});                    
                }
                
                
            });
        
        }
    }

    // Range Bunker
    export const fetchRangeBunkerPlay = (id, startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate
        }
        return (dispatch) => { 
            dispatch({ type:RANGEBUNKERPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchrangebunker', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_RANGEBUNKERPLAY, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const addRangeBunkerPlay = (data, id) =>{
    
        var payload={
            "student":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGEBUNKERPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addrangebunker', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeBunkerPlay(id)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_RANGEBUNKERPLAY});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const getRangeBunkerPlay = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGEBUNKERPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getrangebunker', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: GET_RANGEBUNKERPLAY, payload: resdata.data[0]});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editRangeBunkerPlay = (data, id, stdid) =>{
    
        var payload={
            "id":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGEBUNKERPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editrangebunker', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeBunkerPlay(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_RANGEBUNKERPLAY});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteRangeBunkerPlay = (id, stdid) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGEBUNKERPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleterangebunker', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeBunkerPlay(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_RANGEBUNKERPLAY});                    
                }
                
                
            });
        
        }
    }


    